import { render, staticRenderFns } from "./NotificationMenu.vue?vue&type=template&id=415f653e&scoped=true"
import script from "./NotificationMenu.vue?vue&type=script&lang=js"
export * from "./NotificationMenu.vue?vue&type=script&lang=js"
import style0 from "./NotificationMenu.vue?vue&type=style&index=0&id=415f653e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415f653e",
  null
  
)

export default component.exports